module.exports = __webpack_public_path__ + "img/02n.e63f89f9.svg";